import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Snackbar } from '@mui/material';
import axios from 'axios';



const API_URL = process.env.REACT_APP_API_URL;

const CreateAreaOfInterest = () => {
    const [name, setName] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');  // 'success' or 'error'

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Create the area of interest object
        const areaOfInterest = {
            name: name,
        };

        try {
            const response = await axios.post(`${API_URL}/api/areas-of-interest/create/`, areaOfInterest);
            setSnackbarMessage('Area of Interest created successfully!');
            setSnackbarSeverity('success');
            setOpenSnackbar(true);
            // Clear the form field
            setName('');
        } catch (error) {
            setSnackbarMessage('Failed to create Area of Interest.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        }
    };

    return (
        <Box sx={{ width: '100%', maxWidth: 600, margin: 'auto', padding: 3 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Create a New Area of Interest
            </Typography>

            <form onSubmit={handleSubmit}>
                <TextField
                    label="Area of Interest Name"
                    variant="outlined"
                    fullWidth
                    value={name}
                    onChange={handleNameChange}
                    margin="normal"
                    required
                />
                <Box mt={2}>
                    <Button variant="contained" color="primary" type="submit">
                        Create Area of Interest
                    </Button>
                </Box>
            </form>

            {/* Snackbar for success or error messages */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackbar(false)}
                message={snackbarMessage}
                severity={snackbarSeverity}
            />
        </Box>
    );
};

export default CreateAreaOfInterest;
